import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Card,
  Container,
  Row,
  Col,
  Form,
  Button,
  Table,
} from "react-bootstrap";
import Select from "react-select";
import { triggerBase64Download } from "common-base64-downloader-react";
import SideMenu from "../../UI/SIdeMenu";
import Navibar from "../../UI/Navibar";
import {
  postDepStatisticsReport,
  updateDepStatisticsReport,
  postDepStatisticsExcel,
  resetDepStatisticsReport,
} from "./DepStatisticsSlice";
import { useDispatch, useSelector } from "react-redux";
import Footer from "../../UI/Footer";

function DepStatisticsComponent() {
  const dispatch = useDispatch();
  const { depStatisticsReport, report } = useSelector(
    (state) => state.DepStatisticsSlice
  );

  const [table0, setTable0] = useState([]);
  const [table1, setTable1] = useState([]);
  const [table2, setTable2] = useState([]);
  const { month, year, is_manager } = depStatisticsReport;

  // Define options for month and year
  const monthOptions = [
    { value: 1, label: "JANUARY" },
    { value: 2, label: "FEBRUARY" },
    { value: 3, label: "MARCH" },
    { value: 4, label: "APRIL" },
    { value: 5, label: "MAY" },
    { value: 6, label: "JUNE" },
    { value: 7, label: "JULY" },
    { value: 8, label: "AUGUST" },
    { value: 9, label: "SEPTEMBER" },
    { value: 10, label: "OCTOBER" },
    { value: 11, label: "NOVEMBER" },
    { value: 12, label: "DECEMBER" },
  ];

  const yearOptions = [
    { value: new Date().getFullYear() - 1, label: new Date().getFullYear() - 1 },
    { value: new Date().getFullYear(), label: new Date().getFullYear() },
    { value: new Date().getFullYear() + 1, label: new Date().getFullYear() + 1 }
  ];

  useEffect(() => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();

    const initialDetails = { ...depStatisticsReport, 
      month: currentMonth,
      year: currentYear
    };
    console.log(initialDetails)
    dispatch(updateDepStatisticsReport(initialDetails));
  }, []);

  const handleFormChange = (selectedOption, { name }) => {
    const entity = { ...depStatisticsReport, [name]: selectedOption.value }; // Access label directly
    console.log(entity);
    dispatch(updateDepStatisticsReport(entity));
  };

  const handleClickSearch = (e) => {
    // const entity = { ...depStatisticsReport };
    // dispatch(postDepStatisticsReport(entity)).then((res) => {
    //   console.log(res);
    //   console.log(res.payload);
    //   setTable0(res.payload);
    // });

    // Fetch data for is_manager = 0
    dispatch(postDepStatisticsReport({ ...depStatisticsReport }))
      .then((res) => setTable0(res.payload));

    // Fetch data for is_manager = 1
    dispatch(postDepStatisticsReport({ ...depStatisticsReport, is_manager: 1 }))
      .then((res) => setTable1(res.payload));

    // Fetch data for is_manager = 2
    dispatch(postDepStatisticsReport({ ...depStatisticsReport, is_manager: 2 }))
      .then((res) => setTable2(res.payload));
  };

  const handleExportExcel = () => {
    const entity = { ...depStatisticsReport, table0, table1, table2 };
    console.log(entity)
    dispatch(postDepStatisticsExcel(entity)).then((res) => {
      console.log(res);
      console.log(res.payload);
      const base64EXCEL =
        "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
        res.payload.file;
      triggerBase64Download(
        base64EXCEL,
        "departmentstatistics_report" + "_" + month + "_" + year
      );
    });
  };

  const handleBack = () => {
    const entity = { ...depStatisticsReport,};
    dispatch(resetDepStatisticsReport(entity));
    setTable0([]);
    setTable1([]);
    setTable2([]);
  };

  const renderTable = (tableData, title) => (
    <Table striped bordered hover size="sm">
      <thead>
        <tr>
          <th colspan="1" className="text-start">{title}</th>
          <th rowSpan="2" style={{ verticalAlign: 'middle', textAlign: 'center' }}>NO OF STAFF</th>
          <th rowSpan="2" style={{ verticalAlign: 'middle', textAlign: 'center' }}>TOTAL WORKDAY CHECK IN</th>
          <th colSpan="2">CLOCK IN BTW 830-845</th>
          <th colSpan="2">CLOCK IN AFTER 845</th>
          <th rowSpan="2" style={{ verticalAlign: 'middle', textAlign: 'center' }}>TOTAL LATE</th>
          <th rowSpan="2" style={{ verticalAlign: 'middle', textAlign: 'center' }}>TOTAL LATE (%)</th>
        </tr>
        <tr>
          <th className="text-start">DEPARTMENT</th>
          <th>TOTAL LATE</th>
          <th>LATE (%)</th>
          <th>TOTAL LATE</th>
          <th>LATE (%)</th>
        </tr>
      </thead>
      <tbody>
        {tableData && tableData.length > 0 ? (
          tableData.map((list, index) => (
            <tr key={index}>
              <td className="text-start">{list.description.toUpperCase()}</td>
              <td>{list.no_of_staff}</td>
              <td>{list.total_working_days}</td>
              <td>{list.record_count_830_845}</td>
              <td>
                {list.record_count_830_845_percentage != null && !isNaN(parseFloat(list.record_count_830_845_percentage))
                  ? parseFloat(list.record_count_830_845_percentage).toFixed(2) + '%'
                  : '-'}
              </td>
              <td>{list.record_count_845}</td>
              <td>
                {list.record_count_845_percentage != null && !isNaN(parseFloat(list.record_count_845_percentage))
                  ? parseFloat(list.record_count_845_percentage).toFixed(2) + '%'
                  : '-'}
              </td>
              <td>{list.record_count}</td>
              <td>
                {list.record_count_percentage != null && !isNaN(parseFloat(list.record_count_percentage))
                  ? parseFloat(list.record_count_percentage).toFixed(2) + '%'
                  : '-'}
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="9" className="text-center">No data available</td>
          </tr>
        )}
      </tbody>
    </Table>
  );
  
  return (
    <div className="Div">
      <Container fluid>
      <Row>
          <Col xs={12} className="fixed-top">
            <Navibar />
          </Col>
        </Row>
        <Row>
          <Col xs={2} id="sidebar-wrapper" className="sidemenu"  style={{ marginTop: "50px" }}>
            <SideMenu />
          </Col>
          <Col>
            <Card className="content">
              <Form>
                <Container>
                  <Row className="mb-3 mt-3">
                    <Col md ={12}><h4>DEPARTMENT STATISTICS</h4></Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={3}>
                      <Form.Label>MONTH:</Form.Label>
                    </Col>
                    <Col md={3}>
                      <Select
                        onChange={(option) => handleFormChange(option, { name: "month" })}
                        options={monthOptions}
                        value={monthOptions.find((option) => option.value === month)}
                        placeholder="Select Month"
                      />
                    </Col>
                    <Col md={3}>
                      <Form.Label>YEAR:</Form.Label>
                    </Col>
                    <Col md={3}>
                      <Select
                        onChange={(option) => handleFormChange(option, { name: "year" })}
                        options={yearOptions}
                        value={yearOptions.find((option) => option.value === year)}
                        placeholder="Select Year"
                      />
                    </Col>
                  </Row>
                  <Row className="justify-content-md-center mb-3">
                    <Col xs="auto">
                      <Form.Group>
                        <Button
                          type="button"
                          bg="dark"
                          variant="dark"
                          onClick={handleClickSearch}
                        >
                          SEARCH
                        </Button>
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* Table for is_manager = 0 */}
                  <Card className="mb-4">
                    {/* <Card.Header>Manager Type 0</Card.Header> */}
                    {renderTable(table0, "OVERALL")}
                  </Card>
                  
                  {/* Table for is_manager = 1 */}
                  <Card className="mb-4">
                    {/* <Card.Header>Manager Type 1</Card.Header> */}
                    {renderTable(table1, "MANAGER")}
                  </Card>
                  
                  {/* Table for is_manager = 2 */}
                  <Card className="mb-4">
                    {/* <Card.Header>Manager Type 2</Card.Header> */}
                    {renderTable(table2, "NON-MANAGER")}
                  </Card>

                  <Row className="mb-3 mt-3">
                    <Col md={1}>
                      <Button type="button" bg="dark"
                          variant="dark" onClick={handleBack}>
                        Back
                      </Button>
                    </Col>
                    <Col md={9}></Col>
                    <Col md={2}>
                      <Button type="button" bg="dark"
                          variant="dark" onClick={() => handleExportExcel()}>
                        Export Excel Report
                      </Button>
                    </Col>
                  </Row>
                </Container>
              </Form>
            </Card>
          </Col>
        </Row>
      </Container>

      <Footer />
    </div>
  );
}

export default DepStatisticsComponent;
